import state from "./moduleStatusMobileManagementState";
import mutations from "./moduleStatusMobileManagementMutations";
import actions from "./moduleStatusMobileManagementActions";

export default {
	isRegistered: false,
	namespaced: true,
	state,
	mutations,
	actions,
};
